import { useTracking } from '@packages/tracking';
import type { GTMEventGlycerinDisplayButton } from '@packages/tracking';

export const useMazingTracking = () => {
  const dispatchTracking = useTracking();

  const trackGlycerinDisplayButton = () => {
    dispatchTracking<GTMEventGlycerinDisplayButton>({
      event: 'DisplayButton',
      DisplayButtonData: {
        category: '3D',
        detail: 'Mazing',
      },
    });
  };

  return { trackGlycerinDisplayButton };
};
